import { FormContext } from './formContext';
import { ReactNode, useEffect } from 'react';
import { DefaultValues, FieldValues, FormProvider, useForm, SubmitHandler, Resolver } from 'react-hook-form';

export interface FormProps<T extends FieldValues> {
  children: ReactNode;
  defaultValues?: DefaultValues<T>;
  onSubmit?: SubmitHandler<T>;
  resetAfterSubmit?: boolean;
  isLoading?: boolean;
  resolver?: Resolver<T>;
  validateMode?: 'onChange' | 'onBlur' | 'onSubmit' | 'onTouched';
  readOnly?: boolean;
}

export const Form = <T extends FieldValues>({
  children,
  defaultValues,
  onSubmit,
  resetAfterSubmit = true,
  isLoading = false,
  resolver,
  validateMode = 'onBlur',
  readOnly = false
}: FormProps<T>) => {
  const methods = useForm<T>({ defaultValues, mode: validateMode, resolver });

  useEffect(() => {
    if (methods.formState.isSubmitSuccessful && resetAfterSubmit) {
      methods.reset(defaultValues);
    }
  }, [defaultValues, methods, resetAfterSubmit]);

  return (
    <FormProvider {...methods}>
      <FormContext.Provider value={{ isLoading, readOnly }}>
        <form onSubmit={methods.handleSubmit(onSubmit ?? (() => {}))}>{children}</form>
      </FormContext.Provider>
    </FormProvider>
  );
};
